import React from 'react';
import { Shield, Sparkles, Clock, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PfmeaComingSoon: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="max-w-4xl mx-auto p-8">
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-900 rounded-xl shadow-lg p-12 text-center">
                <div className="flex justify-center mb-6">
                    <div className="relative">
                        <Shield size={80} className="text-indigo-600 dark:text-indigo-400" />
                        <Sparkles size={32} className="text-yellow-500 absolute -top-2 -right-2 animate-pulse" />
                    </div>
                </div>

                <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                    PFMEA Portal
                </h1>

                <div className="flex items-center justify-center gap-2 text-lg text-indigo-600 dark:text-indigo-400 mb-8">
                    <Clock size={20} />
                    <span className="font-semibold">Coming Soon</span>
                </div>

                <p className="text-xl text-gray-700 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
                    The PFMEA (Process Failure Mode and Effects Analysis) Portal is currently under development.
                    This powerful tool will help you analyze manufacturing and assembly process risks with AI-enhanced
                    capabilities similar to the DFMEA Portal.
                </p>

                <div className="bg-white dark:bg-gray-800 rounded-lg p-6 mb-8 shadow-inner">
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                        Planned Features
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                        <div className="flex items-start gap-3">
                            <FileText size={20} className="text-indigo-600 dark:text-indigo-400 mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-semibold text-gray-900 dark:text-white">Process FMEA Analysis</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    Analyze manufacturing and assembly processes for potential failures
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3">
                            <Sparkles size={20} className="text-indigo-600 dark:text-indigo-400 mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-semibold text-gray-900 dark:text-white">AI-Powered Assistance</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    Context-aware Magnus avatar with workflow guidance and intelligent suggestions
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3">
                            <Shield size={20} className="text-indigo-600 dark:text-indigo-400 mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-semibold text-gray-900 dark:text-white">AIAG-VDA Compliance</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    Full compliance checking and validation against AIAG-VDA 2019 standards
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start gap-3">
                            <FileText size={20} className="text-indigo-600 dark:text-indigo-400 mt-1 flex-shrink-0" />
                            <div>
                                <h3 className="font-semibold text-gray-900 dark:text-white">Automated Reporting</h3>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    One-click executive summaries and compliance gap analysis
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="space-y-4">
                    <p className="text-gray-600 dark:text-gray-400">
                        For more information about the planned PFMEA Portal features, see the{' '}
                        <a
                            href="file:///c:/Users/wayne/Desktop/Living Reliability Systems/apps/Magnus-Core/docs/DFMEA_PORTAL_AI_ENHANCEMENT_PLAN.md"
                            className="text-indigo-600 dark:text-indigo-400 hover:underline font-semibold"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            DFMEA Portal AI Enhancement Plan
                        </a>
                        {' '}documentation.
                    </p>

                    <div className="flex gap-4 justify-center mt-8">
                        <button
                            onClick={() => navigate('/dfmea')}
                            className="px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg font-semibold transition-colors"
                        >
                            Explore DFMEA Portal
                        </button>
                        <button
                            onClick={() => navigate('/dashboard')}
                            className="px-6 py-3 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-900 dark:text-white rounded-lg font-semibold transition-colors"
                        >
                            Return to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PfmeaComingSoon;
